<div class="heading">
	<img [src]="getLogo()" alt="Tagme" width="99" height="30" />
</div>

<div class="container">
	<div class="container__body">
		<h1 class="container__header paragraph-color">{{ welcomeMessage(venue?.name?.pt) }}</h1>

		<img
			width="180"
			height="180"
			alt="{{ 'startPage.altImage' | translate }}"
			src="../../../assets/images/qrcode.svg"
		/>

		<p class="paragraph-color">{{ 'startPage.instructions' | translate }}</p>
	</div>
</div>

<footer class="menu__powered-by">
	<a href="{{ isLiveMenuPro ? 'https://landing.tagme.com.br/livemenu-pro/' : 'https://landing.tagme.com.br/live-menu-starter-2/'}}" target="_blank">
		<img
			loading="lazy"
			alt="Powered by Live Menu"
			class="menu__powered-by__logo"
			src="../../../assets/images/powered-by-live-menu.svg"
		/>
	</a>
</footer>
